import {expectOneOf, HttpClient$, POST} from '@raison/network-facade';
import {atom} from 'jotai';

export type WithdrawMethod = {
    type: string;
    id: number;
    currency: string;
};

export const withdrawMethodPost = atom(get => (data: WithdrawMethod) => {
    const http = get(HttpClient$);
    return http('/v1/info/withdraw_method', POST(data)).then(
        expectOneOf({
            200: null,
            401: null,
        })
    );
});
